<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center h-100">
      <!-- First Column -->
      <transition name="fadeCharts" v-if="!hideLeft">
        <div
          class="col text-center"
          v-bind:class="[expandLeft ? 'col-12' : '', 'col-8']"
        >
          <div class="h-100 d-flex flex-column">
            <!-- Row: title and resize button -->
            <div class="row f-row mb-2">
              <div class="markets-chart-title d-flex align-items-center">
                <div class="col col-6" style="font-size: 1rem">
                  <span style="color: var(--textactive)">
                    {{ currencyString.currency_name }}</span
                  >:
                  {{
                    title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
                  }}
                  Candlestick Chart with Survey Forecasts&nbsp;| Last
                  Update:&nbsp;
                  <span style="color: var(--textactive)">
                    {{ lastUpdate | dateFormat }}
                  </span>
                  <div class="ml-auto" v-show="showDumbell">
                    <button
                      @click="expandLeftAnimation"
                      class="zoomCharts btn mr-1"
                      style="width: 12px;"
                    >
                      <i class="fa fa-expand" v-if="expandLeft"></i>
                      <i class="fa fa-compress" v-if="!expandLeft"></i>
                    </button>
                  </div>
                </div>
                <slot name="spot"></slot>
              </div>
            </div>
            <!-- Row: controls and labels -->
            <div
              class="row f-row"
              id="projectionControls"
              style="vertical-align: middle!important;"
            >
              <div
                class="col mr-1"
                v-if="entities.length > 1"
                :class="screenWidth < 1400 ? 'col-3' : 'col-4'"
              >
                <div
                  class="div-mid-align btn-toolbar"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <div
                    class="btn-group btn-group-toggle btn-block"
                    role="group"
                  >
                    <button
                      type="button"
                      class="btn btn-candle"
                      v-on:click="changeEntity('comp')"
                      v-bind:class="[selectedEntity === 'comp' ? 'active' : '']"
                    >
                      Compare
                    </button>
                    <button
                      v-for="(ent, index) in entities"
                      v-bind:key="index"
                      type="button"
                      class="btn btn-candle"
                      v-on:click="changeEntity(ent)"
                      v-bind:class="[selectedEntity === ent ? 'active' : '']"
                    >
                      {{
                        ent.charAt(0).toUpperCase() + ent.slice(1).toLowerCase()
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col col-auto txt-label-primary-2">
                <span style="padding-left: 10px!important;">{{
                  screenWidth > 1400 ? "Compare:" : ""
                }}</span>
              </div>
              <div
                class="col col-auto row-middle-titles text-left slider__container mr-2"
                v-if="updateDateHistData.length > 0"
              >
                <label
                  for="slider_button"
                  class="toggle__button_g"
                  :class="{ actives: activeSlider }"
                >
                  <input
                    type="checkbox"
                    id="slider_button"
                    :disabled="selectedEntity === 'comp'"
                    @click="onUserCompareHistData()"
                    v-model="activeSlider"
                  />
                  <span class="toggle__switch_g"></span>
                </label>
              </div>
              <div
                class="col row-middle-titles text-center slider__container mr-3"
                v-if="updateDateHistData.length > 0"
                :class="screenWidth < 1400 ? 'col-3' : 'col-2'"
              >
                <Slider
                  :dates="updateDateHistData"
                  :newDate="newDateSlider"
                  :minIdx="dateInitial"
                  :isDisabled="!activeSlider"
                  @eventOnRangeChange="eventOnRangeChange"
                  @eventOnValueChange="eventOnValueChange"
                />
              </div>
              <div
                class="col col-cx row-middle-titles"
                style="padding-left: 15px!important;"
              >
                <div
                  class="row f-row"
                  style="background: var(--background); border: 1px solid var(--lightbackground);"
                >
                  <table
                    class="table table-sm table-borderless table-data-controls"
                    style="width: 100%;"
                  >
                    <tbody>
                      <tr class="txt-label-primary-5">
                        <td class="txt-label-primary-5">
                          {{ datePrefix }}
                        </td>
                        <td
                          class="txt-label-primary-5"
                          v-if="selectedEntity !== 'comp'"
                        >
                          Mean:
                        </td>
                        <td
                          class="txt-label-primary-5"
                          v-if="selectedEntity !== 'comp'"
                        >
                          Mean &plusmn; Stdev:
                        </td>
                        <td
                          class="txt-label-primary-5"
                          v-if="selectedEntity !== 'comp'"
                        >
                          Median:
                        </td>
                        <td
                          v-for="(ent, index) in entitiesAux"
                          v-bind:key="index"
                        >
                          {{ ent.str.toUpperCase() }}
                        </td>
                      </tr>
                      <tr>
                        <td class="txt-label-primary">
                          <div
                            id="projectionDate2"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td
                          class="txt-label-primary"
                          v-if="selectedEntity !== 'comp'"
                        >
                          <div
                            id="projectionMean"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td
                          class="txt-label-primary"
                          v-if="selectedEntity !== 'comp'"
                        >
                          <div
                            id="projectionStdev"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td
                          class="txt-label-primary"
                          v-if="selectedEntity !== 'comp'"
                        >
                          <div
                            id="projectionMedian"
                            class="candle-hover-info text-center"
                          >
                            -
                          </div>
                        </td>
                        <td
                          v-for="(ent, index) in entitiesAux"
                          v-bind:key="index"
                        >
                          <div
                            :id="ent.str + 'Mean'"
                            :style="{ color: ent.col }"
                            class="candle-hover-info text-center highlightHover"
                          >
                            -
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Row: Chart -->
            <div class="row f-row h-100" style="position: relative;">
              <!-- Row: legend -->
              <div class="row f-row container-forecast-legends">
                <div class="col col-10 text-left">
                  <table
                    class="table table-sm table-responsive table-borderless table-market-legend"
                    style="width: 100%; background: rgba(0,0,0,0)"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <div class="triangle-topleft"></div>
                          <span class="inline-ul ml-1">Up/Down</span>
                        </td>
                        <td>
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--net)"
                          ></i
                          >MA (20, close)
                        </td>
                        <td>
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--red)"
                          ></i
                          >MA (40, close)
                        </td>
                        <td
                          v-for="(ent, index) in entitiesAux"
                          v-bind:key="index"
                        >
                          <i
                            class="fa fa-minus mr-1"
                            :style="{ color: ent.col }"
                          ></i
                          >{{ ent.str.toUpperCase() }} (Mean)
                        </td>
                        <td v-if="selectedEntity !== 'comp'">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--expo)"
                          ></i
                          >Mean &plusmn; stdev (Survey)
                        </td>
                        <td v-if="selectedEntity !== 'comp'">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--hedge)"
                          ></i
                          >Median (Survey)
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="row f-row"
                style="position: absolute; left: 15px; top: 35px; z-index: 0;"
              >
                <div class="col col-2 text-left">
                  <table
                    class="table table-sm table-borderless table-market-legend"
                    style="background: rgba(0,0,0,0)"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="txt-label-primary-5 text-left"
                          style="width: 5%"
                        >
                          Date:
                          <div
                            id="projectionDate"
                            class="candle-hover-info text-left"
                          >
                            -
                          </div>
                        </td>
                        <td
                          class="txt-label-primary-5 text-left"
                          style="width: 5%"
                        >
                          Close:
                          <div
                            id="projectionClose"
                            class="candle-hover-info text-left"
                          >
                            -
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="col col-12 text-center progress-div"
                v-if="showLoading || showLoadingPJ"
              >
                <QSLoading
                  :isLoading="showLoading || showLoadingPJ"
                  :size="35"
                  :colorTheme="colorTheme"
                />
              </div>
              <div
                class="col col-12 text-center"
                v-else-if="chartData.length === 0"
                style="position: absolute; left: 0; top: 45%; z-index: 10000000;"
              >
                No Data Available
              </div>
              <div class="col col-12" style="height:99%; width:100%">
                <div class="h-100 d-flex flex-column" id="projections-div">
                  <svg id="svg-projections"></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- ======================== //// ============================== -->
      <!-- Second Column -->
      <transition name="fadeCharts" v-if="!hideRight">
        <div
          class="col text-center"
          v-bind:class="[expandRight ? 'col-12' : '', 'col-4']"
        >
          <div class="h-100 d-flex flex-column">
            <!-- Row: title and resize button -->
            <div class="row f-row">
              <div
                class="markets-chart-title d-flex"
                style="border:1px solid var(--green)"
              >
                DUMBELL
                <div class="ml-auto">
                  <button
                    @click="expandRightAnimation"
                    class="zoomCharts btn mr-1"
                    style="width: 12px;"
                  >
                    <i class="fa fa-expand" v-if="!expandRight"></i>
                    <i class="fa fa-compress" v-if="expandRight"></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Row: controls and labels -->
            <div class="row f-row">
              <div class="col col-12" style="border:1px solid var(--blue);">
                Controls and chart information
              </div>
            </div>
            <!-- Row: legend -->
            <div
              class="row f-row h-100"
              style="position: absolute; left: 0; top: 100px; z-index: 0;"
            >
              <div class="col col-1"></div>
              <div class="col col-10 text-left">
                <table
                  class="table table-sm table-responsive table-borderless table-market-legend"
                  style="width: 100%; background: rgba(0,0,0,0)"
                >
                  <tbody>
                    <tr>
                      <td class="text-center">
                        Legend
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Row: Chart -->
            <div class="row f-row h-100">
              <div
                class="col col-12 text-center progress-div"
                v-if="showLoading || showLoadingPJ"
              >
                <QSLoading
                  :isLoading="showLoading || showLoadingPJ"
                  :size="35"
                  :colorTheme="colorTheme"
                />
              </div>
              <div
                class="col col-12 text-center"
                v-else-if="chart2Data.length === 0"
                style="position: absolute; left: 0; top: 45%; z-index: 10000000;"
              >
                No Data Available
              </div>
              <div class="col col-12" style="height:100%; width:100%">
                <div class="h-100 d-flex flex-column" id="dumbell-div">
                  <svg id="svg-dumbell"></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  colorExpo,
  colorExpoAlpha,
  colorExpoAlpha2,
  colorHedge,
  colorNet,
  colorRed,
  colorSelection3,
  currencyFormat,
  grayLightBackground,
  prefixOptions,
  tDays,
  tFormat,
  tIntervals,
  titleTexts,
  colorFwdAlpha4,
  colorFwdF,
} from "@/_core/_helpers/_parametric_tools";
import { D3Chart } from "@/_core/charts/D3Chart";
import {
  D3HoverForecast,
  D3HoverForecastFuture,
} from "@/_core/charts/D3ChartHoverEffects";
import { select, timeFormat, selectAll } from "d3";
import {
  formatDate_YMD,
  getUniqueValues,
  lengthByDate,
  timeParseNull2,
} from "@/_core/_helpers/_helpers";
import { gatewayService } from "@/_services/gateway.service";
import Slider from "../analytics/Slider.vue";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "Forecast",
  components: {
    QSLoading,
    Slider,
  },
  props: {
    chartDataRaw: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    currencyNumber: { required: true },
    currencyString: { required: true },
    dataReady: { required: true },
    expandLeft: { required: true },
    hideRight: { required: true },
    processData: { required: true },
    showDumbell: { required: true },
    showLoading: { required: true },
    spot: { required: true },
  },
  data() {
    return {
      dateInitial: 0,
      updateDateHistData: [],
      actualDateSlider: "",
      lastestHistDataScatter: [],
      activeSlider: false,
      // ========== Data =============
      chart2Data: [],
      chartData: [],
      colorSelection: JSON.parse(JSON.stringify(colorSelection3)).reverse(),
      currencyFormat: currencyFormat,
      D3Chart: null,
      d3HoverForecast: null,
      D3HoverForecastFuture: null,
      dateFormat: "%d %b %y",
      datePrefix: "Date:",
      entities: [],
      entitiesAux: [],
      expandRight: false,
      hideLeft: false,
      interval: "day",
      lastUpdate: "...",
      newDateSlider: -1,
      pickedDate: "1Y",
      prefixOptions: prefixOptions,
      projectionReady: false,
      projections: [],
      projectionsEntities: [],
      projectionsEntitiesRaw: [],
      projectionsHist: [],
      projectionsRaw: [],
      selectedDays: 261,
      selectedEntity: null,
      showLoadingPJ: false,
      screenWidth: 0,
      tDays: tDays,
      tFormat: tFormat,
      tIntervals: tIntervals,
      title: "DAILY",
      titleTexts: titleTexts,
    };
  },
  created() {
    this.D3Chart = new D3Chart("projections-div", "svg-projections");
    this.d3HoverForecast = new D3HoverForecast();
    this.D3HoverForecastFuture = new D3HoverForecastFuture();
  },
  mounted() {
    this.showLoadingPJ = true;

    if (this.spot !== null) {
      this.getProjections();
    }

    if (this.chartDataRaw.length > 0) {
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map((d) => d.date),
      );
      this.dataPrepHist();
      if (this.projectionReady) {
        this.createProjectionChart();
      }
    }

    let _this = this;
    _this.updateScreenWidth();
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  watch: {
    colorTheme() {
      this.callWidth();
    },
    showLoading() {
      if (this.showLoading) {
        this.chartData = [];
        this.projections = [];
        this.projectionsRaw = [];
        select("#svg-projections")
          .select("svg > *")
          .remove();
      }
    },
    dataReady() {
      this.dataPrepHist();
      this.callWidth();
    },
    projectionReady() {
      this.callWidth();
    },
    spot() {
      if (this.spot !== null) {
        this.getProjections();
        this.includeSpot("chartDataRaw");
      }
    },
  },
  methods: {
    eventOnRangeChange(val) {
      this.createScatter(val);
      this.actualDateSlider = val;
    },
    // ============== core ==================
    dataPrepHist() {
      this.chartData = this.processData.toSlice(
        this.chartDataRaw,
        this.selectedDays,
      );
      if (this.interval !== "day") {
        this.chartData = this.processData.ohlcNest(
          this.chartData,
          this.interval,
        );
      }
    },
    createProjectionChart() {
      if (this.chartData.length > 0 && this.projections.length > 0) {
        // === set SVG canvas
        this.svgNode = this.D3Chart.setSVG(
          0.025,
          10,
          0.5,
          60,
          0.05,
          50,
          0.025,
          12,
        );
        let minMaxYAxis = this.processData.minMax(
          this.chartData,
          "high",
          "low",
        );
        minMaxYAxis = this.processData.minMax(
          this.projections,
          "up",
          "dn",
          minMaxYAxis,
        );
        if (this.selectedEntity !== "comp") {
          const fltrData = this.projections.filter(
            (d) => d.update_date != null,
          );
          minMaxYAxis = this.processData.minMax(
            fltrData,
            "max",
            "min",
            minMaxYAxis,
          );
        }
        let del = 0.05 * (minMaxYAxis[1] - minMaxYAxis[0]);
        minMaxYAxis = [minMaxYAxis[0] - del, minMaxYAxis[1] + del];
        // === set axis
        this.svgNode = this.D3Chart.setAxis(
          this.svgNode,
          this.chartData.concat(this.projections),
          minMaxYAxis,
          this.dateFormat,
          60,
          8,
          false,
          [],
          true,
          true,
          false,
          [],
          false,
        );
        // === vertical line at today
        this.svgNode
          .append("line")
          .attr("stroke-width", 1)
          .attr("stroke-opacity", 0.3)
          .attr("stroke", grayLightBackground(this.colorTheme))
          .attr("x1", this.svgNode.x(this.projections[0].date))
          .attr("y1", 0)
          .attr("x2", this.svgNode.x(this.projections[0].date))
          .attr("y2", this.svgNode.height);
        // === candles
        this.svgNode = this.D3Chart.candles(
          this.svgNode,
          this.chartData,
          colorExpo(this.colorTheme),
          grayLightBackground(this.colorTheme),
          "PJ",
          0.75,
          0.25,
        );
        // === MA20 line
        this.D3Chart.line(
          this.svgNode,
          this.chartData,
          colorNet(this.colorTheme),
          2,
          "ma20",
        );
        // === MA40 line
        this.D3Chart.line(
          this.svgNode,
          this.chartData,
          colorRed(this.colorTheme),
          2,
          "ma40",
        );
        // === custom hover effects and info
        this.d3HoverForecast.hoverFct(
          this.svgNode,
          this.chartData,
          "PJ",
          this.dateFormat,
          this.currencyFormat,
          this.colorTheme,
        );

        if (this.selectedEntity !== "comp") {
          // max scatter
          let fltrData = this.projections.filter((d) => d.update_date != null);
          this.D3Chart.scatterSym(
            this.svgNode,
            fltrData,
            "triangle",
            180,
            colorExpoAlpha2(this.colorTheme),
            colorExpo(this.colorTheme),
            "date",
            "max",
          );
          // min scatter
          this.D3Chart.scatterSym(
            this.svgNode,
            fltrData,
            "triangle",
            0,
            colorExpoAlpha2(this.colorTheme),
            colorExpo(this.colorTheme),
            "date",
            "min",
          );
          // hist scatter
          let histDataScatter = this.projectionsHist.filter(
            (d) => d.entity === this.selectedEntity,
          );
          const lastDates = histDataScatter.slice(-24);
          console.log("lastDates", lastDates);

          this.lastestHistDataScatter = histDataScatter.reduce((accum, d) => {
            const currentValue = d.update_date.getTime();

            const hasUpdateDate = lastDates.find(
              (date) => date.update_date.getTime() === currentValue,
            );
            if (hasUpdateDate) accum.push(d);
            return accum;
          }, []);
          this.updateDateHistData = getUniqueValues(
            lastDates.map((d) => d.update_date),
          ).slice(-12);
          console.log("this.updateDateHistData", this.updateDateHistData);
          if (this.activeSlider) {
            this.eventOnRangeChange(this.actualDateSlider);
          }

          // === add projection +- stdev range
          this.D3Chart.linesArea(
            this.svgNode,
            this.projections,
            colorExpo(this.colorTheme),
            colorExpo(this.colorTheme),
            2,
            colorExpoAlpha(this.colorTheme),
            "up",
            "dn",
            true,
            2,
            true,
          );
          // === mean line
          this.D3Chart.line(
            this.svgNode,
            this.projections,
            colorExpo(this.colorTheme),
            2,
            "mean",
          );
          // === median line
          this.D3Chart.line(
            this.svgNode,
            this.projections,
            colorHedge(this.colorTheme),
            2,
            "median",
          );
          // === add hover Fx for Forecast Chart/part
          this.D3HoverForecastFuture.hoverFct(
            this.svgNode,
            this.projections,
            "PJF",
            this.dateFormat,
            this.currencyFormat,
            colorExpo(this.colorTheme),
            "white",
            colorHedge(this.colorTheme),
            "white",
            true,
            [],
          );
        } else {
          this.D3Chart.multiLine(
            this.svgNode,
            this.projectionsEntities,
            this.colorSelection,
            2,
          );
          // === add hover Fx for Forecast Chart/part
          this.D3HoverForecastFuture.hoverFct(
            this.svgNode,
            this.projectionsEntitiesRaw,
            "PJF",
            this.dateFormat,
            this.currencyFormat,
            this.colorSelection,
            "white",
            colorHedge(this.colorTheme),
            "white",
            false,
            this.entities,
          );
        }
      }
    },
    includeSpot(fieldName) {
      if (this.spot != null && this.spot !== 0 && Number.isFinite(this.spot)) {
        let nLen = this[fieldName].length - 1;
        this[fieldName][nLen].high = Math.max(
          this.spot,
          this[fieldName][nLen].high,
        );
        this[fieldName][nLen].low = Math.min(
          this.spot,
          this[fieldName][nLen].low,
        );
        this[fieldName][nLen].close = this.spot;
      }
    },
    createScatter(date) {
      const matchingDates = this.lastestHistDataScatter.filter(
        (d) => JSON.stringify(d.update_date) === JSON.stringify(date),
      );
      selectAll(".square").remove();
      this.D3Chart.scatterSym(
        this.svgNode,
        matchingDates,
        "square",
        45,
        colorFwdAlpha4(this.colorTheme),
        colorFwdF(this.colorTheme),
        "date",
        "mean",
      );
    },
    // ==================== User ====================
    _pickedDate(paramInterval) {
      this.pickedDate = paramInterval;
      this.interval = "day"; // this.tIntervals[this.pickedDate];
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map((d) => d.date),
      );
      this.dateFormat = this.tFormat[this.interval];
      this.datePrefix = this.prefixOptions[this.interval];
      this.title = this.titleTexts[this.interval];
      this.dataPrepHist();
      this.createProjectionChart();
    },
    changeEntity(ent) {
      let _this = this;
      this.selectedEntity = ent;
      let entAux = this.selectedEntity !== "comp" ? [] : this.entities;
      this.entitiesAux = [];
      entAux.map(function(d, i) {
        _this.entitiesAux.push({ str: d, col: _this.colorSelection[i] });
      });
      if (this.selectedEntity === "comp") {
        this.activeSlider = false;
        selectAll(".tooltipForecast").style("opacity", 0);
        this.projections = this.projectionsRaw.filter(
          (d) => d.entity === _this.entities[0],
        );
      } else {
        this.projections = this.projectionsRaw.filter(
          (d) => d.entity === _this.selectedEntity,
        );
      }
      this.createProjectionChart();
      if (this.activeSlider) {
        this.eventOnRangeChange(this.actualDateSlider);
      }
    },
    eventOnValueChange(value) {
      this.newDateSlider = value;
    },
    onUserCompareHistData() {
      this.eventOnValueChange();
      this.activeSlider = !this.activeSlider;
      if (!this.activeSlider) {
        this.newDateSlider = -1;
        selectAll(".square").remove();
        selectAll(".tooltipForecast").style("opacity", 0);
      } else {
        this.eventOnRangeChange(this.actualDateSlider);
      }
    },
    // ================== animations ================
    expandLeftAnimation() {
      if (!this.expandLeft) {
        this.hideRight = true;
        setTimeout(() => {
          this.expandLeft = !this.expandLeft;
        }, 50);
        for (let i = 0; i < 22; i++) {
          // setTimeout(() => { this.renderSeasonalMethod(); }, (i + 1) * 50);
        }
      } else {
        this.expandLeft = !this.expandLeft;
        setTimeout(() => {
          this.hideRight = false;
        }, 100);
        setTimeout(() => {
          // this.renderCandlesMethod();
          // this.renderSeasonalMethod();
        }, 300);
      }
    },
    expandRightAnimation() {
      if (!this.expandRight) {
        this.hideLeft = true;
        setTimeout(() => {
          this.expandRight = !this.expandRight;
        }, 50);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            this.renderCandlesMethod();
          }, (i + 1) * 50);
        }
      } else {
        this.expandRight = !this.expandRight;
        setTimeout(() => {
          this.hideLeft = false;
        }, 100);
        setTimeout(() => {
          this.renderSeasonalMethod();
          this.renderCandlesMethod();
        }, 300);
      }
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    callWidth() {
      this.updateScreenWidth();
      if (this.projectionReady) {
        this.createProjectionChart();
      }
    },
    // ================== API calls =================
    getProjections() {
      let _this = this;
      this.showLoadingPJ = true;
      this.projectionReady = false;
      let dt = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      const variables = {
        format: "json",
        last: 1,
        currency: this.currencyNumber,
        spot: this.spot,
        observation_date: formatDate_YMD(dt),
      };
      return gatewayService.currencies
        .forecastMeasures(variables)
        .then((data) => {
          let _this = this;
          data = JSON.parse(JSON.stringify(data));
          let hist = data.filter((d) => d.type === "hist");
          hist.forEach(function(d) {
            d.update_date = timeParseNull2(d.update_date);
            d.date = timeParseNull2(d.date);
            delete d.currency_name;
            delete d.long_name;
            delete d.median;
            delete d.mode;
            delete d.median;
            delete d.max;
            delete d.min;
            delete d.type;
            delete d.short_name;
            delete d.standard_dev;
          });
          hist = hist.sort((a, b) => a.update_date - b.update_date);
          Object.assign(this, { projectionsHist: hist });
          data = data.filter((d) => d.type === "current");
          let found = false;
          data.forEach(function(d) {
            d.update_date = timeParseNull2(d.update_date);
            d.date = timeParseNull2(d.date);
            d.up = d.mean + d.standard_dev;
            d.dn = d.mean - d.standard_dev;
            if (!found && d.update_date != null) {
              _this.lastUpdate = d.update_date;
              found = true;
            }
          });
          let ent = data.map((d) => d.entity).sort();
          this.entities = ent.filter(this.processData.onlyUnique);
          this.selectedEntity = this.entities[0];
          this.entitiesAux =
            this.selectedEntity !== "comp" ? [] : this.entities;
          this.projectionsRaw = data;
          this.changeEntity(this.selectedEntity);
          if (this.entities.length > 1) {
            let dat = [],
              datAux,
              obj;
            datAux = this.projectionsRaw.filter(
              (d) => d.entity === _this.entities[0],
            );
            datAux.forEach(function(d) {
              obj = { date: d.date };
              obj[_this.entities[0]] = d.mean;
              dat.push(obj);
            });
            for (let i = 1; i < this.entities.length; i++) {
              datAux = this.projectionsRaw.filter(
                (d) => d.entity === _this.entities[i],
              );
              dat.forEach(function(d, j) {
                d[_this.entities[i]] = datAux[j].mean;
              });
            }
            this.projectionsEntitiesRaw = dat;
            this.projectionsEntities = this.processData.dataPrepMultiLines(
              "Compare",
              "",
              this.entities,
              dat,
              "date",
            );
          } else {
            this.projectionsEntitiesRaw = [];
            this.projectionsEntities = [];
          }
          this.projectionReady = true;
          this.showLoadingPJ = false;
        })
        .catch(function(error) {
          _this.projectionReady = false;
          _this.showLoadingPJ = false;
          console.error(error);
        });
    },
  },
  filters: {
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%b %d, %y")(val);
    },
  },
};
</script>

<style scoped>
.p-slider-horizontal {
  width: 170px;
}
.table-data-controls tr td,
.table-data-controls tr th {
  white-space: nowrap;
}
#projectionControls {
  padding: 0 60px 0 12px;
}
.toggle__button_g {
  width: 100%;
}
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "" !important;
}
label.toggle__button_g {
  padding-left: 5px;
}
.slider__container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.slider__title {
  font-size: 0.9rem;
}
.actives .toggle__switch_g::after {
  background: var(--dark-fwd);
  border: 1px solid var(--fwd);
  box-shadow: 0 0 1px var(--graylightbackground);
}
.slider__container {
  align-items: center;
}
.slider__container label.toggle__button_g {
  min-width: 50px;
  max-width: 60px;
}
.toggle__button_g .toggle__switch_g {
  max-height: 12px;
}
.container-forecast-legends {
  position: absolute;
  left: 15px;
  top: 15px;
  z-index: 0;
}
@media (max-width: 1300px) {
  #projectionControls {
    padding: 0 0 0 12px;
  }
}
/* @media (min-width: 1440px) {
  .container-forecast-legends {
    top: 11vh;
  }
} */
</style>
